// Seleccionamos todos los elementos con la clase 'toggle'
document.querySelectorAll('.toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function(event) {
        event.preventDefault(); // Prevenir el comportamiento por defecto del enlace
        this.classList.toggle('active'); // Alternar la clase 'active'
        
        // Buscar la sub-lista asociada y alternar su visibilidad
        let subList = this.nextElementSibling;
        if (subList.style.display === "block") {
            subList.style.display = "none";
        } else {
            subList.style.display = "block";
        }
    });

});

    let selectedWaist = null;
    let selectedInseam = null;

    // Función para seleccionar la variante basada en waist y inseam
    function selectVariant() {
        if (selectedWaist && selectedInseam) {
            const variantValue = `${selectedWaist}/${selectedInseam}`;
            const variantInput = document.querySelector(`input[type="radio"][value="${variantValue}"]`);
            
            if (variantInput) {
                variantInput.click();
                variantInput.checked = true;
                console.log('Variant found:', variantValue);
            } else {
                console.log('Variant not found:', variantValue);
            }
        }
    }


    // Function to update the availability of inseam options based on the selected waist
    function updateInseamOptions() {
        const inseamItems = document.querySelectorAll('.sub-list.inseam li');
        inseamItems.forEach(item => {
            const inseamValue = item.getAttribute('data-inseam');
            const variantValue = `${selectedWaist}/${inseamValue}`;
            const variantInput = document.querySelector(`input[type="radio"][value="${variantValue}"]`);

            if (variantInput && (variantInput.disabled || variantInput.classList.contains('disabled'))) {
                item.classList.add('disabled');
                item.classList.remove('available');
            } else if (variantInput) {
                item.classList.remove('disabled');
                item.classList.add('available');
            } else {
                item.classList.add('disabled');
                item.classList.remove('available');
            }
        });
    }



     // Listener para las opciones de waist
    document.querySelectorAll('.sub-list.waist li').forEach(function (item) {
        item.addEventListener('click', function () {
        // Remove 'active' class from all items
        document.querySelectorAll('.sub-list.waist li').forEach(i => i.classList.remove('active'));
        // Add 'active' class to the clicked item

        // Capturar el valor del item seleccionado
        const selectedValue = this.textContent.trim();
            
        // Cerrar el colapso automáticamente
        //const subList = this.closest('.sub-list');
        //subList.style.display = 'none';

        // Añadir o actualizar el span con el valor seleccionado
        let waistSelectedSpan = document.getElementById("waist-value-selected");
       
        waistSelectedSpan.textContent = ':  ' + selectedValue;


        this.classList.add('active');
        selectedWaist = this.getAttribute('data-waist');
        updateInseamOptions(); // Update inseam options based on selected waist
        selectVariant();
        });
    });

    // Listener para las opciones de inseam
    document.querySelectorAll('.sub-list.inseam li').forEach(function (item) {
        item.addEventListener('click', function () {
        // Remove 'active' class from all items
        document.querySelectorAll('.sub-list.inseam li').forEach(i => i.classList.remove('active'));
        // Add 'active' class to the clicked item

         // Capturar el valor del item seleccionado
         const selectedValue = this.textContent.trim();
            
         // Cerrar el colapso automáticamente
         //const subList = this.closest('.sub-list');
         //subList.style.display = 'none';
 
         // Añadir o actualizar el span con el valor seleccionado
        let inseamSelectedSpan = document.getElementById("inseam-value-selected");
        inseamSelectedSpan.textContent = ':  ' + selectedValue;

        this.classList.add('active');
        selectedInseam = this.getAttribute('data-inseam');
        selectVariant();
        });
    });







  